<template>
  <TableGradient
      icon-name="cubes"
      :title="$t('tuevs.examresult.listagem.titulo_pagina')"
      :text-empty="$t('tuevs.component.listagem.table.empty')"
      table-data
      route-new="tuevs.examresult.create"
      :text-new="$t('tuevs.examresult.listagem.novo')"
      :fields="fields"
      :items="examresults"
      :loading="isLoading"
      :paginator="pagination"
      @list="evt => $store.dispatch('tuevs/examresult/listAllPaginated', {...evt, order_by: 'name'})">
    <template v-slot:cell(status)="{item}">
      <span
          :class="{'rounded-pill p-1 badge': true, 'badge-success':item.status, 'badge-danger': !item.status}">
          <em v-if="item.status">{{ $t('tuevs.examresult.listagem.habilitado') }}</em>
          <em v-else>{{ $t('tuevs.examresult.listagem.desabilitado') }}</em>
      </span>
    </template>
    <template v-slot:cell(id)="{index, item}">
      <router-link :id="`link-edit-${index}`"
                   :to="{ name: 'tuevs.examresult.edit', params: { id: item.id }}"
                   class="font-weight-bold">
        {{ $t('tuevs.examresult.listagem.table.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      store_isLoading: 'tuevs/examresult/isLoading',
      examresults: 'tuevs/examresult/all',
      pagination: 'tuevs/examresult/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('tuevs.examresult.listagem.table.nome'), sortable: true},
        {key: 'code', label: this.$t('tuevs.examresult.listagem.table.codigo'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('tuevs.examresult.listagem.table.editar')}
      ]
    }
  },
  methods: {
    ...mapActions([
      'tuevs/examresult/listAllPaginated'
    ])
  },
  mounted() {
    this['tuevs/examresult/listAllPaginated']({...this.pagination, order_by: 'name'})
    this.mounted = true
  }
}
</script>
